// Számlázási profilok feature — query-kulcs gyár + a lista-szűrő típusa. A tényleges hívásokat a route/komponens
// a tipizált ts-rest kliensen (`api.billingProfiles.*`) intézi; a kulcsok itt élnek (cache-egységesítés).
// A `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs-logika van (az invoices feature-mintára).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A `sort` a rendezés-KULCS (billingName | clientName | taxNumber), az `order` az irány; a `q` (szabad-szöveg,
 *  a keresőben) és az `onlyPrimary` (csak-elsődleges kapcsoló) a szűrők. (Ügyfél-szűrő nincs — a kereső fedi.) */
export interface BillingProfileListFilters {
  q: string;
  onlyPrimary: boolean;
  sort: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista/refs cache egységes címzése (invalidálás + a create-form ügyfél-választója). */
export const billingProfileKeys = {
  all: ['billing-profiles'] as const,
  lists: () => ['billing-profiles', 'list'] as const,
  list: (filters: BillingProfileListFilters) => ['billing-profiles', 'list', filters] as const,
  /** A create-form ügyfél-választójának refs-adata (foundation clients). */
  clientRefs: () => ['billing-profiles', 'client-refs'] as const,
};
